import { Permissions, EntityAccess, REPORTS_PERMISSION_PREFIX } from '@lanterds/types';
import { useEffect, useState } from 'react';
import { getAdminPermissions } from 'src/api/userManagement';

export const cachePermissions = (userId: string) => {
    const userPermissions: any = sessionStorage.getItem(userId);

    const needsToBeWiped =
        !userPermissions ||
        userPermissions['shippingPortal.returns'] ||
        userPermissions['shippingPortal.returns'] ||
        userPermissions['shippingPortal.transfers'] ||
        userPermissions['reports.totalVisPlsReport'] ||
        userPermissions['reports.totalVisVolumeReport'];

    const [isCached, setIsCached] = useState(!!userPermissions);
    const { data, isFetching } = getAdminPermissions(userId, !!userId && (!userPermissions || needsToBeWiped));

    useEffect(() => {
        if (userPermissions) {
            setIsCached(true);
        }
    }, [userPermissions]);

    useEffect(() => {
        if (data && data.permissions) {
            sessionStorage.setItem(userId, JSON.stringify(data.permissions));
            setIsCached(true);
        }
    }, [data, isFetching]);

    return isCached;
};

export const isAuthorized = (userId: string, permissionName?: Permissions, entityAccess?: EntityAccess) => {
    // const isCached = cachePermissions(userId);
    let permissions = null;

    const userPermissions = sessionStorage.getItem(userId);
    if (userPermissions) {
        permissions = JSON.parse(userPermissions);
    }

    if (
        permissions &&
        permissionName &&
        permissions[permissionName] &&
        (!entityAccess ||
            permissions[permissionName].filter((entity: EntityAccess) => {
                if (entity.type === 'accessAllCustomers') {
                    return entity.type === entityAccess.type;
                } else {
                    let result = false;
                    result = entity.type === entityAccess.type;
                    result = 'id' in entityAccess && entity.id === entityAccess.id;
                    return result;
                }
            }).length > 0)
    ) {
        return true;
    }
    return false;
};

export const isAuthorizedToViewSomeReports = (userId: string) => {
    let permissions = null;

    const userPermissions = sessionStorage.getItem(userId);
    if (userPermissions) {
        permissions = JSON.parse(userPermissions);
    }

    return Object.keys(permissions).some((key) => key.startsWith(REPORTS_PERMISSION_PREFIX));
};
